class SupabaseClient extends HTMLElement {
  constructor() {
    super();

    // Initialize Supabase Client using global 'supabase' object from CDN
    this.SUPABASE_URL = 'https://vijlqstvcnwfwyfcvzqv.supabase.co';
    this.SUPABASE_PUBLIC_KEY =
      'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZpamxxc3R2Y253Znd5ZmN2enF2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjQyNTU5ODUsImV4cCI6MjAzOTgzMTk4NX0.oc8SSQ7RR7vBkx0W2Axya-l1RBt_g5V8QNKYW2rZaVY';
    this.SUPABASE_SCAN_QR_CODE_URL = 'https://vijlqstvcnwfwyfcvzqv.supabase.co/functions/v1/process-qr-code-scans';
    this.SUPABASE_FECTH_REPORT_URL = 'https://vijlqstvcnwfwyfcvzqv.supabase.co/functions/v1/build-report-data';

    this.supabaseClient = window.supabase.createClient(this.SUPABASE_URL, this.SUPABASE_PUBLIC_KEY);

    this.authForm = this.querySelector('#login-form');
    this.loginForm = this.querySelector('#login-form-wrapper');
    this.authMessage = this.querySelector('#auth-message');
    this.errorMessage = this.querySelector('#error-message');
    this.statusContainer = this.querySelector('#status-container');
    this.statusMessage = this.querySelector('#status-message');
    this.loader = this.querySelector('#loader');
    this.completedMessage = this.querySelector('#completed-message');

    this.authForm.addEventListener('submit', this.handleLogin.bind(this));
  }

  async handleLogin(event) {
    event.preventDefault();

    const email = this.querySelector('#email').value;
    const password = this.querySelector('#password').value;

    // Sign in with Supabase Auth
    const { data, error } = await this.supabaseClient.auth.signInWithPassword({
      email,
      password,
    });

    if (error) {
      this.errorMessage.textContent = `Error: ${error.message}`;
      return;
    }

    // Save JWT for later use
    localStorage.setItem('supabaseClientAuthJWT', data.session.access_token);

    this.setLoggedInState();
    this.callEdgeFunction();
  }

  setLoggedInState() {
    this.loginForm.style.display = 'none';
    this.statusContainer.style.display = 'block';
  }

  setLoggedOutState() {
    this.loginForm.style.display = 'block';
    this.statusContainer.style.display = 'none';
    localStorage.removeItem('supabaseClientAuthJWT');
  }

  setStatus(isLoading, statusMessage, completedMessage = '') {
    this.statusMessage.innerHTML = `<p>${statusMessage}</p>`;
    if (isLoading) {
      this.loader.style.display = 'block';
      this.completedMessage.style.display = 'none';
    } else {
      this.loader.style.display = 'none';
      this.completedMessage.style.display = 'block';
      this.completedMessage.innerHTML = completedMessage;
    }
  }

  // eslint-disable-next-line no-empty-function
  async callEdgeFunction() {}
}

if (!customElements.get('community-sale-scans-handler')) {
  class CommunitySaleScans extends SupabaseClient {
    constructor() {
      super();
    }

    connectedCallback() {
      if (!localStorage.getItem('supabaseClientAuthJWT')) return;

      this.setLoggedInState();
      this.callEdgeFunction();
    }

    async callEdgeFunction() {
      this.setStatus(true, 'Loading...');
      try {
        const response = await fetch(this.SUPABASE_SCAN_QR_CODE_URL, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${localStorage.getItem('supabaseClientAuthJWT')}`,
            'Content-Type': 'application/json',
          },
        });

        switch (response.status) {
          case 401:
            this.setLoggedOutState();
            this.setStatus(false, 'Failed', 'Unauthorized, please login again');
            break;

          case 200:
            this.setStatus(false, 'Completed', 'Scan Completed Successfully! <br> Please close this page if you want to scan another QR Code.');
            break;
        }
      } catch (error) {
        this.setStatus(false, 'Failed', error);
      }
    }
  }

  customElements.define('community-sale-scans-handler', CommunitySaleScans);
}

if (!customElements.get('community-sale-reports-handler')) {
  class CommunitySaleReports extends SupabaseClient {
    constructor() {
      super();
    }

    connectedCallback() {
      if (!localStorage.getItem('supabaseClientAuthJWT')) return;

      this.setLoggedInState();
      this.callEdgeFunction();
    }

    async callEdgeFunction() {
      this.setStatus(true, 'Loading...');
      try {
        const response = await fetch(this.SUPABASE_FECTH_REPORT_URL, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${localStorage.getItem('supabaseClientAuthJWT')}`,
            'Content-Type': 'application/json',
          },
        });

        switch (response.status) {
          case 401:
            this.setLoggedOutState();
            this.setStatus(false, 'Failed', 'Unauthorized, please login again');
            break;

          case 200: {
            const data = await response.json();
            this.setStatus(false, 'Completed', `The total number of scans is: <br> <strong>${data.total_number_of_scans}</strong>`);
            break;
          }
        }
      } catch (error) {
        this.setStatus(false, 'Failed', error);
      }
    }
  }

  customElements.define('community-sale-reports-handler', CommunitySaleReports);
}
